<template>
    <div class="AIInterlocutor-left">
        <div class="flex-row cursor_1 t-p-l-20 t-p-r-27" style="height: 70px;border-bottom:1px solid #F6F6F7;"
            @click="$router.replace('/')">
            <img class="top_l2" src="@/assets/logo.png" alt="">
            <img class="top_l3" src="@/assets/image/top_icon.png" alt="">
        </div>
        <div class="noSearch">
            <div class="ai_add t-p-l-27 t-p-r-27">
                <transition name="input-fade">
                    <el-button type="primary" round class="add_btn cursor_1" @click.stop="newCreate"
                        v-show="!isExpanded">
                        <span class="btn_title"><i class="el-icon-plus"
                                style="font-weight: bold;padding-right: 8px;"></i>新建对话</span></el-button>
                </transition>
                <div class="search-container">
                    <div :class="['search-button', { 'expanded': isExpanded }]" @click.stop="toggleSearch">
                        <transition name="icon-move">
                            <div class="search-icon-wrapper" :key="isExpanded">
                                <!-- <i class="el-icon-search search-icon"></i> -->
                                <img src="@/assets/image/ai_wenda/icon4.png" width="16" height="16" />
                            </div>
                        </transition>
                        <transition name="input-fade">
                            <el-input v-if="isExpanded" v-model="keyword" @input="AISearchInput" class="search-input"
                                placeholder="请输入搜索内容" ref="searchInput" clearable>
                                <!-- <i v-show="keyword" slot="suffix" class="el-icon-error"></i> -->
                            </el-input>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="hisotryMain">
                <!-- <div class="flex t-p-l-27 t-p-r-27">
                    <p class="flex-row"><span class="dot"></span>
                    <div style="position: relative;"><span class="historyTitle t-m-l-7">历史记录</span><span
                            class="bottom_bg"></span>
                    </div>
                    </p>
                </div> -->
                <div class="historyList t-p-l-27 t-p-r-20">
                    <div class="item" v-for="(item, i) in historyList" :key="item.id" @click.stop="selected(item)"
                        :class="curIndex == item.id ? 'isSelected' : ''">
                        <span class='u-line-1'>{{ item.title }}</span>
                        <span class="tool">
                            <i class="el-icon-delete" @click.stop="delHistory(item)"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import { EventBus } from '@/utils/eventBus'
import AnApi from '@/api/answer.js'
export default {
    data() {
        return {
            openSearch: false,
            searchList: [],
            historyList: [],
            curIndex: null,//当前会话
            keyword: '',//搜索的关键字
            searchStatus: true,
            isExpanded: false,
        }
    },
    created() {
        EventBus.$on('updateList', (sessionId) => {
            this.curIndex = sessionId
            this.init()
        })
        window.addEventListener('click', this.curClick)
        this.init()
    },
    beforeDestroy() {
        window.removeEventListener('click', this.curClick)
    },
    methods: {
        init() {
            AnApi.answerHistoryList().then(res => {
                if (res.code === 200) {
                    this.historyList = res.data
                    this.searchList = _.cloneDeep(this.historyList);
                    let sessionId = sessionStorage.getItem(this.sessionIdKey)
                    if (sessionId) {
                        this.curIndex = sessionId
                    }

                }
            })
        },
        curClick() {
            if (!this.keyword) {
                this.isExpanded = false
            }
        },
        toggleSearch() {
            this.isExpanded = true
            if (this.isExpanded) {
                this.$nextTick(() => {
                    this.$el.querySelector('.search-input input').focus()
                })
            }
        },
        //开启新对话
        newCreate() {
            this.curIndex = null
            EventBus.$emit('newCreate')
        },
        AISearchInput: _.debounce(function (e) {
            if (!e) {
                this.curClick()
                this.historyList = this.searchList
                return
            }
            this.historyList = this.searchList.filter(item => item.title.indexOf(e) != -1)
        }, 300),
        //选择某项记录
        selected(item) {
            if (this.curIndex === item.id) return
            this.curIndex = item.id
            EventBus.$emit('send', item)
        },
        //删除记录
        delHistory(item) {
            this.$confirm('删除后，该对话将不可恢复。确认删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                AnApi.answerDel({ ids: item.id }).then(as => {
                    if (as.code === 200) {
                        this.$message.success('删除成功！')
                        //重新调用
                        this.init()
                        EventBus.$emit('newCreate')
                    }
                })
            }).catch(() => {
                this.$message('已取消删除')
            });
        }
    }
}
</script>
<style lang="scss" scoped>
p {
    margin: 0;
    padding: 0;
}

.AIInterlocutor-left {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    padding: 0 0 25px;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        border-right: 1px solid #F6F6F7;
    }
}

.noSearch {
    flex: 1;
    flex-direction: column;
    display: flex;
    overflow: auto;
    width: 292px;

    .ai_add {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;

        .add_btn {
            width: 171px !important;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 18px;
            background-color: #3665FF;
            border: 0;

            .btn_title {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
            }
        }

        .search {
            margin: auto;

            ::v-deep(.el-input__inner) {
                width: 220px !important;
                border-radius: 18px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #333;
                background-color: #FFFFFF;
            }

            ::v-deep(.el-input__prefix) {
                top: 10px;
                left: 10px;
            }
        }
    }
}


.hisotryMain {
    margin-top: 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: var(--tech-primary);
    }

    .historyTitle {
        position: relative;
        height: 16px;
        line-height: 1;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #000000;
        z-index: 2;
    }

    .bottom_bg {
        position: absolute;
        bottom: 0;
        left: 6px;
        width: 58px;
        height: 7px;
        z-index: 1;
        // background-color: red;
        background: linear-gradient(90deg, #FFE2C3, #FFFFFF);
        border-radius: 4px;
    }

    .historyList {
        overflow: auto;
        flex: 1;
        // margin-top: 20px;
        @include scrollbar();

        &:hover {
            @include scrollbar_hover();
        }

        .item:first-child {
            margin-top: 0 !important;
        }

        .item {
            // margin-top: 24px;
            margin-top: 10px;
            height: 36px;
            display: flex;
            align-items: center;
            padding: 0 30px 0 15px;
            border-radius: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            position: relative;

            &:hover {
                background: #EEF1FE;
                color: #3665FF;
                cursor: pointer;

                .tool {
                    display: block !important;
                }
            }

            .tool {
                position: absolute;
                right: 10px;
                z-index: 1;
                display: none;

                i {
                    &:hover {
                        cursor: pointer;
                        color: #3665FF;
                    }
                }
            }
        }
    }
}

.isSelected {
    background: #EEF1FE !important;
    color: #3665FF !important;

    .tool {
        display: block !important;
    }
}
</style>
<style lang="scss" scoped>
$button-size: 40px;
$button-radius: $button-size / 2;
$expanded-width: 220px;
$icon-size: 24px;
$primary-color: #fff;
$text-color: #000000;
$placeholder-opacity: 0.7;
$transition-time: 0.3s;

.search-container {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
}

.search-button {
    position: relative;
    width: $button-size;
    height: $button-size;
    border-radius: $button-radius;
    background-color: $primary-color;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all $transition-time ease;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    // 初始状态 - 图标居中
    .search-icon-wrapper {
        position: absolute;
        width: $icon-size;
        height: $icon-size;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all $transition-time ease;
        left: 50%;
        transform: translateX(-50%);

        .search-icon {
            font-size: $icon-size - 6; // 18px
            color: $text-color;
        }
    }

    // 展开状态
    &.expanded {
        width: $expanded-width;
        justify-content: flex-start;
        padding-left: 15px;

        .search-icon-wrapper {
            left: 15px;
            transform: translateX(0);
        }
    }

    .search-input {
        width: calc(100% - #{$button-size});
        margin-left: $button-size;

        ::v-deep .el-input__inner {
            border: none;
            background-color: transparent;
            color: $text-color;
            padding-left: 0;
            width: 100%;

            &::placeholder {
                color: rgba($text-color, $placeholder-opacity);
            }

            &:focus {
                outline: none;
                box-shadow: none;
            }
        }
    }
}

// 图标移动动画
.icon-move-enter-active,
.icon-move-leave-active {
    transition: all $transition-time ease;
}

.icon-move-enter,
.icon-move-leave-to {
    opacity: 0;
    transform: translateX(20px);
}

// 输入框淡入动画
.input-fade-enter-active,
.input-fade-leave-active {
    transition: all $transition-time ease;
}

.input-fade-enter,
.input-fade-leave-to {
    opacity: 0;
    transform: translateX(-10px);
}
</style>